export default __webpack_public_path__ + "static/3-9c09740e46cbd8a9139ec4c33e8573c4.png";